const url = new URL(window?.location)
const params = url.searchParams

function save(prop, value) {
	'' === value ? params.delete(prop) : params.set(prop, value)

	window?.history.replaceState(null, '', url)
}

export function queryStore(prop) {
	const subscribers = new Set()

	return {
		subscribe: callback => {
			subscribers.add(callback)
			callback(params.get(prop))

			return () => subscribers.delete(callback)
		},
		set: value => {
			save(prop, value)

			for (const callback of subscribers)
				callback(value)
		},
	}
}
